// EXEMPLO SINTETICO DA PLANILHA DE TESTE — as mesmas celulas de
// `__fixtures__/planilha-retorno.celulas.json`, como constante, pela razao de
// sempre: o dominio nao le disco (ADR-0007). A borda transforma estas celulas
// em .xlsx na hora de servir o `exemplo.zip`; o dominio nunca ve bytes.
//
// GERADO do .json; `planilha-retorno.test.ts` afirma que os dois continuam
// identicos, e que os tres .csv equivalentes dizem a mesma coisa em texto.
//
// Nada aqui e' dado real. O que cada peculiaridade exercita:
//   - duas linhas de titulo antes do cabecalho, em toda aba;
//   - CPF que perdeu os zeros a esquerda por ter viajado como numero;
//   - CPF com mascara;
//   - matricula com sufixo de vinculo (`-A`);
//   - data como serial de planilha (admissao) e como `aaaa-mm-dd` (mes de referencia);
//   - valor com ponto decimal, e valor com separador de milhar;
//   - colunas da aba de descontos fora da ordem declarada.
export const TESTE_PLANILHA_SERVIDORES = [
    ["Relatório de servidores — Unidade de Exemplo", "", "", "", "", "", "", "", "", "", "", ""],
    ["Competência 09/2026 — exportado do sistema de folha", "", "", "", "", "", "", "", "", "", "", ""],
    [
        "Matricula",
        "CPF",
        "Nome",
        "Situacao",
        "Vinculo",
        "Cargo",
        "Admissao",
        "Salario",
        "Banco",
        "Agencia",
        "Conta",
        "MesReferencia",
    ],
    [
        "1300509-A",
        "100000037",
        "SERVIDOR SINTÉTICO UM",
        "AT",
        "EFETIVO",
        "ANALISTA",
        "40182",
        "3517.31",
        "237",
        "6076",
        "600000",
        "2026-09-01",
    ],
    [
        "1300510",
        "115.308.642-59",
        "SERVIDOR SINTÉTICO DOIS",
        "AT",
        "COMISSIONADO",
        "TÉCNICO",
        "40576",
        "12,345.67",
        "001",
        "6077",
        "600013",
        "2026-09-01",
    ],
    [
        "1300511",
        "258.421.533-00",
        "SERVIDOR SINTÉTICO TRÊS",
        "LI",
        "EFETIVO",
        "AUXILIAR",
        "40973",
        "4034.62",
        "104",
        "6078",
        "600026",
        "2026-09-01",
    ],
];
export const TESTE_PLANILHA_DESCONTOS = [
    ["Extrato de descontos consignados — Unidade de Exemplo", "", "", "", ""],
    ["Competência 09/2026 — uma linha por contrato", "", "", "", ""],
    ["Verba", "Matricula", "Valor", "Contrato", "Descricao"],
    ["854", "1300509-A", "233.17", "9471423", "EMPRÉSTIMO CONSIGNADO"],
    ["971", "1300509-A", "1,234.56", "9471424", "CARTÃO BENEFÍCIO"],
    ["854", "1300510", "1696.87", "9471425", "EMPRÉSTIMO CONSIGNADO"],
    ["641", "1300511", "174.26", "9471426", "PLANO DE SAÚDE"],
];
export const TESTE_PLANILHA_HOLERITE = [
    ["Holerite consolidado — Unidade de Exemplo", "", "", "", ""],
    ["Competência 09/2026 — proventos e descontos", "", "", "", ""],
    ["Matricula", "Verba", "Descricao", "Tipo", "Valor"],
    ["1300509-A", "001", "VENCIMENTO BASE", "P", "3517.31"],
    ["1300509-A", "854", "EMPRÉSTIMO CONSIGNADO", "D", "233.17"],
    ["1300509-A", "971", "CARTÃO BENEFÍCIO", "D", "1,234.56"],
    ["1300510", "001", "VENCIMENTO BASE", "P", "12,345.67"],
    ["1300510", "854", "EMPRÉSTIMO CONSIGNADO", "D", "1696.87"],
    ["1300511", "001", "VENCIMENTO BASE", "P", "4034.62"],
    ["1300511", "641", "PLANO DE SAÚDE", "D", "174.26"],
];
/** As tres abas, na ordem em que a planilha as traz. */
export const TESTE_PLANILHA_ABAS = [
    { aba: "Servidores", celulas: TESTE_PLANILHA_SERVIDORES },
    { aba: "Descontos", celulas: TESTE_PLANILHA_DESCONTOS },
    { aba: "Holerite", celulas: TESTE_PLANILHA_HOLERITE },
];
/** A competencia que o exemplo declara, na coluna `MesReferencia` da aba de servidores. */
export const TESTE_PLANILHA_COMPETENCIA = "202609";
//# sourceMappingURL=planilha-exemplo.js.map